import { useAchievementsStore } from '@store'

export const useUserAchievements = () => {
  const achievements = useAchievementsStore.store.achievements()
  const isLoading = useAchievementsStore.store.isLoading()
  const error = useAchievementsStore.store.error()

  return { achievements, isLoading, error }
}
